import {Swiper, SwiperSlide} from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
var axios = require('axios')
var CONFIG = require('@/common/config.js')
var base_url = CONFIG.API_URL.BASE_URL
var img_url = CONFIG.API_URL.IMG_URL

export default {
  name: 'swiper-example-navigation',
  title: 'Navigation',
  components: {
    Swiper,
    SwiperSlide
  },
  data () {
    return {
      base_url: base_url,
      isImg:'',
      solutionimg: [
        {
          icon: 'icon-zhengfujiguan',
          name: '政府',
          tiptop: '创新场景',
          tip: '赋能政务信息化',
          discript1: '超过70个城市提供整体解决方案',
          discript2: '应用范围覆盖了10个省、自治区、直辖市',
          discript3: '地方政府用户已经超过了100家'
        },
        {
          icon: 'icon-icon_xinyong_xianxing_jijin-157',
          name: '金融',
          tiptop: '场景创新',
          tip: '打造智慧新金融',
          discript1: '深耕金融行业十余年',
          discript2: '服务客户涉及全国1000多家金融机构',
          discript3: '持续关注金融数据安全领域的技术发展'
        },
        {
          icon: 'icon-yiliaofuwuzhan',
          name: '医卫',
          tiptop: '辰图IT',
          tip: '让医疗更轻松',
          discript1: '深耕医疗行业十余年',
          discript2: '深入医疗机构各业务场景，不断创新产品和解决方案',
          discript3: '各类解决方案已服务于全省500余家医院'
        },
        {
          icon: 'icon-zhaogaoxiao',
          name: '高校',
          tiptop: '融智于教',
          tip: '场景创新',
          discript1: '全国90余个教育网域网',
          discript2: '600余所大学及专科院校',
          discript3: '支撑各级基础教育信息化应用的安全高效运行'
        },
        {
          icon: 'icon-yidong',
          name: '通信',
          tiptop: '辰图大数据',
          tip: '运营商信赖的合作伙伴',
          discript1: '安徽移动、安徽电信大数据安全服务顾问',
          discript2: '为运营商打造专项安全方案',
          discript3: '全方位保护数据隐私不留漏洞'
        }
      ],
      imgTitle: [
        {
          img: '../../static/images/Image 80.png',
          text: '地级市政府'
        },
        {
          img: '../../static/images/Image 81.png',
          text: '各地市委办局'
        },
        {
          img: '../../static/images/Image 82.png',
          text: '三甲医院'
        },
        {
          img: '../../static/images/Image 83.png',
          text: '高校'
        }
      ],
      // serviceText: [
      //   '安徽省经信中心',
      //   '芜湖市数据资源管理局',
      //   '淮南市数据资源管理局',
      //   '安庆市数据资源管理局',
      //   '亳州市数据资源管理局',
      //   '蚌埠市数据资源管理局',
      //   '安医大附属第一人民医院',
      //   '芜湖市第二人民医院',
      //   '中国科大附属安徽省立医院',
      //   '安徽省公安厅',
      //   '安徽电信',
      //   '安徽移动'
      // ],
      serviceText: [
        '黄山市数据资源管理局',
        '中国移动通信集团安徽有限公司', // '安徽移动',
        '安徽商贸职业技术学院',
        '全知科技（杭州）有限责任公司', // '全知科技',
        '中国信息通讯院',
        '安徽工程大学'
        // '启明星辰',
        // '中孚信息',
        // '安徽工程大学',
        // '安徽电信'
      ],
      guidenceInfo: [
        {
          icon: 'icon-anquan',
          title: '安全管理标准',
          text: '为数据安全管理工作提供标准化的目标、组织、任务和内容，实现标准化管理'
        },
        {
          icon: 'icon-liuchengguanli',
          title: '安全工作流程',
          text: '为数据安全管理工作提供标准化的目标、组织、任务和内容，实现标准化管理'
        },
        {
          icon: 'icon-dingdanqueren',
          title: '安全运营规范',
          text: '为数据安全管理工作提供标准化的目标、组织、任务和内容，实现标准化管理'
        },
        {
          icon: 'icon-tuandui',
          title: '技术支持体系',
          text: '为数据安全管理工作提供标准化的目标、组织、任务和内容，实现标准化管理'
        },
        {
          icon: 'icon-rise',
          title: '评价考核指标',
          text: '为数据安全管理工作提供标准化的目标、组织、任务和内容，实现标准化管理'
        }
      ],
      successimg: '/static/images/casebg.jpg',
      serviceimg: '../../static/images/Image 5.png',
      headImg: '../../static/images/homeHead.png',
      coreitem: [],
      imgtitle: '../../static/images/Image 4.png',
      partnerimg: [],
      successimgs: [],
      bannerList: [],
      newsInfo: [],
      islight: 0,
      add: 0,
      add2: 0,
      add3: 0,
      isdefult: 'core-text',
      isimg: 'core-img',
      isActive: 'solution-containerB',
      defulte: 'solution-container',
      swiperpartnerOption: {
        slidesPerView: 1,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        pagination: {
          el: '.swiper-pagination'
        }
      },
      swipersuccessOption: {
        slidesPerView: 1,
        // slideToClickedSlide: true,
        allowTouchMove: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        pagination: {
          el: '.swiper-success-pagination',
          clickable: true
        }
      }
    }
  },
  created () {
    // 获取解决方案模块
    // this.getSolutionList()
    // 新闻动态
    this.getNewList()
    // 成功客户
    // this.getCustomerList()
    // 合作伙伴
    // this.getPartnerList()
    // 核心服务
    this.getCoreList()
  },
  mounted () {
    setInterval(this.pollData, 3000)
  },
  methods: {
    changeActive ($event) {
      $event.currentTarget.className = 'current'
    },
    removeActive ($event) {
      $event.currentTarget.className = ''
    },
    changeCore ($event) {
      this.add = $event.target.dataset.id
    },
    changeGuidance ($event) {
      this.add2 = $event.target.dataset.id
    },
    changeNews ($event) {
      this.add3 = $event.target.dataset.id
    },
    prevsuccess () {
      this.$refs.mysuccessswiper.$swiper.slidePrev()
      this.$refs.mysuccessswiper.$swiper.setTranslate(0)
    },
    nextsuccess () {
      this.$refs.mysuccessswiper.$swiper.slideNext()
      this.$refs.mysuccessswiper.$swiper.setTranslate(0)
    },
    changeLight ($event) {
      var active = $event.target.dataset.index
      console.log(active)
      this.islight = active
    },
    changeImg ($event) {
      this.isImg = $event.target.dataset.id
    },
    getSolutionList () {
      var that = this
      axios.post(base_url + 'front/getSolutionList', {}).then(function (res) {
        console.log(res)
        if (res.data.code == 0) {
          var result = res.data.result
          for (var i = 0; i < result.length; i++) {
            var solution = []
            solution['imgUrl'] = result[i]['imgUrl']
            // solution['title'] = result[i]['title']
            solution['name'] = result[i]['title']
            solution['class_name'] = 'so' + (i + 1)
            that.solutionimg.push(solution)
          }
        }
      }).catch(function (err) {
        // console.log(err)
      })
    },
    getNewList () {
      var that = this
      axios.post(base_url + 'front/getNewList', {}).then(function (res) {
        var result = res.data.result
        if (res.data.code == 0) {
          for (var i = 0; i < 3; i++) {
            var News = []
            News['imgUrl'] = img_url + result[i]['imgUrl']
            News['name'] = result[i]['title']
            News['id'] = result[i]['id']
            News['contents'] = result[i]['brief']
            News['year'] = result[i]['addTime'].substr(0, 4)
            News['date'] = result[i]['addTime'].substr(5, 5)
            that.newsInfo.push(News)
          }
        }
      }).catch(function (err) {
        // console.log(err)
      })
    },
    getCoreList () {
      var that = this
      axios.post(base_url + 'front/getInfoCateList', {'type': 1 }).then(function (res) {
        var result = res.data.result
        // console.log(result,'111')
        for (var i = 0; i < 4 ;i++) {
          var News = []
          News['img'] = img_url + result[i]['imgUrl']
          News['text'] = result[i]['name']
          News['id'] = result[i]['id']
          that.coreitem.push(News)
        }
      }).catch(function (err) {
        console.log(err)
      })
    },
    service: function (e){
     var id = e.currentTarget.dataset.id;
      this.$router.push({ path: '/service',query:{id:id}});
      localStorage.setItem("navIndex","2");
    },
    soluton: function (){
      this.$router.push({ path: '/solution',query:{id:26}});
      localStorage.setItem("navIndex","3");
    },
    //资讯详情
    newsDetail:function($event){
      var that = this;
      var id = $event.currentTarget.dataset.id;
      that.$router.push({ path: '/newsDetail?id='+id });
      //储存导航标识
      localStorage.setItem("navIndex","5");
    },
    getCustomerList () {
      var that = this
      axios.post(base_url + 'front/getCustomerList', {}).then(function (res) {
        var result = res.data.result
        for (var i = 0; i < result.length; i++) {
          var News = []
          News['imgUrl'] = result[i]['imgUrl']
          News['name'] = result[i]['name']
          that.successimgs.push(News)
        }
      }).catch(function (err) {
        console.log(err)
      })
    },
    getPartnerList () {
      var that = this
      axios.post(base_url + 'front/getPartnerList', {}).then(function (res) {
        var result = res.data.result
        for (var i = 0; i < result.length; i++) {
          that.partnerimg.push(result[i]['imgUrl'])
        }
      }).catch(function (err) {
        console.log(err)
      })
    }
  },
  computed: {
    pages () {
      const pages = []
      this.partnerimg.forEach((item, index) => {
        const page = Math.floor(index / 6)
        if (!pages[page]) {
          pages[page] = []
        }
        pages[page].push(item)
      })
      return pages
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/home/home.js